import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

const ImagesLink = ({ shipmentKey, shipmentProductKey, disabled }) => {
    const classes = classNames("button", {
        "-disabled": disabled,
    });

    return (
        <a
            href={`/image-browser/${shipmentKey}/${shipmentProductKey}`}
            className={classes}
            target="_blank"
            rel="noopener noreferrer"
        >
            <FontAwesomeIcon icon={faImages} />
        </a>
    );
};

export default ImagesLink;
